module.exports = __webpack_public_path__ + "static/media/MSS LOGO-white.2f19fff6.png";